import homeController from './home.controller';

export default angular
  .module('st.Home', ['st.Core'])
  .controller('homeController', homeController);
